import React from 'react';
import { hydrate, hydrateRoot } from 'react-dom';
import { HeaderB2b } from '../../components/header-ui/b2b/HeaderB2b';
import { Footer } from '../../components/footer-ui/Footer';
import { hfClientManager } from '../builder/client-side-builder';
import HeaderClientContext from '../../components/header-ui/HeaderClientContext';

const headerApp = (
  <HeaderClientContext>
    <HeaderB2b />
  </HeaderClientContext>
);

const headerRootElement = document.getElementById('header-static-b2b');

if (headerRootElement?.hasChildNodes()) {
  if (hydrateRoot !== undefined) {
    hydrateRoot(headerRootElement, headerApp);
  } else {
    hydrate(headerApp, headerRootElement);
  }

  const footerRootElement = document.getElementById('footer-static-b2b');
  if (footerRootElement?.hasChildNodes()) {
    if (hydrateRoot !== undefined) {
      hydrateRoot(footerRootElement, <Footer customerType="b2b" />);
    } else {
      hydrate(<Footer customerType="b2b" />, footerRootElement);
    }
  }

} else {
  // prerender HTML does not exist, fallback to client-side render
  hfClientManager.headerfooter.buildAndRender({
    headerNode: headerApp,
    footerNode: <Footer customerType="b2b" />,
    isB2B: true,
    footerId: 'footer-static-b2b',
    headerId: 'header-static-b2b'
  });
}
